import { Form, Formik } from 'formik';
import React, { useState } from 'react'
import FormObserver from '../../FormElements/FormObserver';
import { FormInput } from '../../FormElements';
import FormMaskedInput from '../../FormElements/FormMaskedInput';
import { Button } from '../../Elements';
import { whatsappSettingsSchema } from '../../../../common/validators/whatsappSettingsSchema';
import commonNetwork from '../../../../common/api/commonNetwork';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { get } from 'http';
import { getFirmWhatsappInfo } from '../../../../store/slices/firmWhatsappInfoSlice';

interface WhatsappSettingsProps {
    firmWhatsappInfoParameters: any
}

const WhatsappSettings: React.FC<WhatsappSettingsProps> = ({ firmWhatsappInfoParameters }) => {

    const initialValues = {
        firmWaNumber: firmWhatsappInfoParameters ? firmWhatsappInfoParameters.firmWaNumber != null ? firmWhatsappInfoParameters.firmWaNumber : '' : '',
        linkTempleteId: firmWhatsappInfoParameters ? firmWhatsappInfoParameters.linkTempleteId != null ? firmWhatsappInfoParameters.linkTempleteId : '' : '',
        errorTempleteId: firmWhatsappInfoParameters ? firmWhatsappInfoParameters.errorTempleteId != null ? firmWhatsappInfoParameters.errorTempleteId : '' : '',
        successTempleteId: firmWhatsappInfoParameters ? firmWhatsappInfoParameters.successTempleteId != null ? firmWhatsappInfoParameters.successTempleteId : '' : '',
        srcName: firmWhatsappInfoParameters ? firmWhatsappInfoParameters.srcName != null ? firmWhatsappInfoParameters.srcName : '' : '',
        confirmCodeTempleteId: firmWhatsappInfoParameters ? firmWhatsappInfoParameters.confirmCodeTempleteId != null ? firmWhatsappInfoParameters.confirmCodeTempleteId : '' : '',
    }

    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

    const [formValues, setFormValues] = useState(initialValues);
    const [loading, setLoading] = useState(false)

    const onSubmit = async () => {
        try
        {
            setLoading(true);
        const params = {
            firmWaNumber: formValues.firmWaNumber,
            linkTempleteId: formValues.linkTempleteId,
            errorTempleteId: formValues.errorTempleteId,
            successTempleteId: formValues.successTempleteId,
            srcName: formValues.srcName
        }

        const response = await commonNetwork.post("/FirmWhatsappInfo/saveFirmWhatsappInfo", params);

        if (response.isSuccess) {
            dispatch(getFirmWhatsappInfo());
            toast.success("Kayıt işlemi başarılı.");
        } else {
            toast.error("Kayıt işlemi başarısız.");
        }
        }
        catch(error)
        {
            console.error("Kayıt işlemi sırasında bir hata oluştu:", error);
        }
        finally
        {
            setLoading(false);
        }
    }

    return (
        <div>
            <Formik
                enableReinitialize
                initialValues={formValues}
                onSubmit={onSubmit}
                validationSchema={whatsappSettingsSchema}
            >
                {({
                    values,
                    setFieldValue
                }) => (
                    <Form>
                        <FormObserver
                            watch={(val: any) => {
                                setFormValues(val);
                            }}
                        />
                        <>
                            <div className="px-4  py-2  bg-white shadow-md space-y-4  mt-2 my-1 rounded-md">
                                <div className=" px-3 mt-3 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3 ">
                                    <div className="mt-1">
                                        <h1 className="font-bold text-contrast-90">
                                            WhatsApp Bağlantı Ayarları
                                        </h1>
                                        <span className="text-contrast-50 text-md">
                                            Müşterilerinizle iletişim kuracağınız resmi WhatsApp işletme numaranızı ve gönderici kimlik bilgilerinizi buradan yönetebilirsiniz.
                                        </span>
                                    </div>
                                    <div className="w-full  col-span-2">
                                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 mb-3">
                                            <div className="">
                                                <FormMaskedInput
                                                    label="Whatsapp İşletme Numarası*"
                                                    name="firmWaNumber"
                                                    maskOptions={{
                                                        delimiter: ' ',
                                                        blocks: [3, 3, 2, 2],
                                                        numericOnly: true
                                                    }}
                                                    placeholder="5xx xxx xx xx"
                                                />
                                            </div>
                                            <div className="">
                                                <FormInput
                                                    label="Uygulama Kaynak Adı (Source Name)"
                                                    name="srcName"
                                                    maxLength={251}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <hr />

                                <div className=" px-3 mt-3 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3 ">
                                    <div className="mt-1">
                                        <h1 className="font-bold text-contrast-90">
                                            Mesaj Şablon Tanımlamaları (Template IDs)
                                        </h1>
                                        <span className="text-contrast-50 text-md">
                                            WhatsApp üzerinden gönderilecek otomatik mesajların (link, başarı veya hata bildirimleri) şablon ID'lerini giriniz.
                                        </span>
                                    </div>
                                    <div className="w-full  col-span-2">
                                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 mb-3">
                                            <div className="">
                                                <FormInput
                                                    label="Ödeme/Link Paylaşım Şablon ID"
                                                    name="linkTempleteId"
                                                    maxLength={101}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 mb-3">
                                            <div className="">
                                                <FormInput
                                                    label="Başarı Bildirim Şablon ID"
                                                    name="successTempleteId"
                                                    maxLength={101}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 mb-3">
                                            <div className="">
                                                <FormInput
                                                    label="Hata/Red Bildirim Şablon ID"
                                                    name="errorTempleteId"
                                                    maxLength={101}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-4 py-3  w-full justify-end flex flex-row">
                                    <Button
                                        size="xl"
                                        color="primary"
                                        hover="primary"
                                        type="submit"
                                        loading={loading}
                                    >
                                        Kaydet
                                    </Button>
                                </div>
                            </div>
                        </>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default WhatsappSettings